import styles from "./WorksPage.module.scss";
import MyWorks from "../../entities/MyWorks/ui/MyWorks";


const WorksPage = () => {
    return ( 
        <main className={styles.main}>
        <div className={styles.container}>
            <MyWorks/>
        </div>
        </main>
     );
}
 
export default WorksPage;